import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import PolicyGroupTemplateGalleryMainPanel from 'client/groups/Configuration/PolicyGroupTemplateGalleryMainPanel';
import PolicyGroupTemplateManage from 'client/groups/Configuration/PolicyGroupTemplateManage.vue';

const metaData = {
  title: 'Policy Group Templates',
};

export default (enabledFlags) => [
  {
    path: '/groups/configuration/grouptemplates',
    name: 'policyGroupTemplates',
    meta: metaData,
    components: {
      mainPanel: PolicyGroupTemplateGalleryMainPanel,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.policyGroupTemplateGallery];
      const routeOrRedirect = showRoute ? true : { path: '/groups/configuration' };
      next(routeOrRedirect);
    },
    props: {
      mainPanel: {
        initialTabIndex: 0,
      },
    },
  },
  {
    path: '/groups/configuration/managetemplates',
    name: 'policyGroupTemplatesManage',
    meta: {
      title: 'Manage Policy Group Templates',
    },
    components: {
      mainPanel: PolicyGroupTemplateManage,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.policyGroupTemplateManage];
      const routeOrRedirect = showRoute ? true : { path: '/groups/configuration' };
      next(routeOrRedirect);
    },
    props: {
      mainPanel: {
        activeTab: 'grouptemplates',
      },
    },
  },
];
